import { useCallback, useEffect, useState } from "react";
import GroupedTableRow from "./GroupedTableRow";
import type {
  EditedRowProps,
  ExpandingRowDefinition,
  TableProps,
  TableRowDefinition,
} from "./types";

interface ExpandingTableRowProps {
  row: ExpandingRowDefinition;
  index: number;
}

const ExpandingTableRow = ({
  index,
  row,
  ...props
}: ExpandingTableRowProps & TableProps & EditedRowProps) => {
  const {
    meta: { fetchChildren, fetchKey },
    ...restRow
  } = row;

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onExpandClick = useCallback(async () => {
    setIsOpen(true);
  }, []);

  const [children, setChildren] = useState<TableRowDefinition[]>([]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: restRow is defined in this component so will be re-created on every render
  useEffect(() => {
    const fetch = async () => {
      if (isOpen) {
        const data = await fetchChildren(restRow);
        setChildren(data);
      }
    };
    fetch();
  }, [isOpen, fetchChildren]);

  return (
    <GroupedTableRow
      row={{
        header: restRow,
        children: children || [],
      }}
      index={index}
      onExpand={onExpandClick}
      {...props}
    />
  );
};

export default ExpandingTableRow;
